module.exports = function() {
  return new Worker(__webpack_public_path__ + "dc56f6a1abf71184c439.worker.js");
};